// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"580":"6b872b62","955":"88d814d2"}[chunkId] + ".css";
};